import { motion } from "framer-motion";
import { Filter } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useModelDialog } from "../hooks";
import { ModelSuggestionCard } from "@/features/chat/components/renderers/ModelSuggestionCard";
import type { AIModel } from "../store/ai-model-store";

export const ModelGrid = () => {
  const { t } = useTranslation();
  const { filteredModels, isLoadingMore } = useModelDialog();

  if (filteredModels.length === 0) {
    return (
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.2 }}
        className="flex flex-col items-center justify-center h-40 text-center"
      >
        <Filter className="h-12 w-12 text-muted-foreground mb-4" />
        <p className="text-lg font-medium text-gray-900 dark:text-white mb-2">
          {t("aiModelSelection.noResults")}
        </p>
        <p className="text-sm text-muted-foreground">
          {t("aiModelSelection.tryDifferentSearch")}
        </p>
      </motion.div>
    );
  }

  return (
    <>
      {/* Mobile: Kompakt liste görünümü, Desktop: Grid */}
      <div className="flex flex-col gap-3 sm:grid sm:grid-cols-2 xl:grid-cols-4 sm:gap-4 sm:auto-rows-fr">
        {filteredModels.map((model: AIModel, index: number) => (
          <motion.div
            key={`${model._id}-${index}`}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.2, delay: index * 0.02 }}
            className="h-full"
          >
            {/* Mobile: Kompakt horizontal card */}
            <div className="sm:hidden">
              <ModelSuggestionCard
                model={model}
                // MessageModelSuggestions tarafından enjekte edilen __messageId değerini wizard'a taşı
                messageId={(model as any).__messageId}
                isModelGrid={true}
                isMobileCompact={true}
              />
            </div>
            {/* Desktop: Normal vertical card */}
            <div className="hidden sm:block h-full">
              <ModelSuggestionCard
                model={model}
                messageId={(model as any).__messageId}
                isModelGrid={true}
              />
            </div>
          </motion.div>
        ))}
      </div>

      {/* Loading indicator */}
      {isLoadingMore && (
        <div className="flex justify-center mt-6">
          <div className="w-8 h-8 border-2 border-gray-300 border-t-transparent rounded-full animate-spin" />
        </div>
      )}
    </>
  );
};
